window.initImageTabs = function(sectionId) {
  var prefix = "#" + sectionId;
  
  var tabs  = document.querySelectorAll(prefix + " .images-with-tabs__tab-btn");
  var texts = document.querySelectorAll(prefix + " .images-with-tabs__text-item");
  var imgs  = document.querySelectorAll(prefix + " .images-with-tabs__img");
  var activeIdx = 0;
  var isLocked  = false;

  function showTab(idx) {
    if (idx === activeIdx) return;

    texts[activeIdx].classList.add("hidden");
    imgs[activeIdx].classList.add("hidden");
    tabs[activeIdx].classList.remove("active");

    texts[idx].classList.remove("hidden");
    imgs[idx].classList.remove("hidden");
    tabs[idx].classList.add("active");

    activeIdx = idx;
  }

  tabs.forEach(function(btn) {
    var idx = parseInt(btn.getAttribute("data-index"), 10);

    btn.addEventListener("mouseenter", function() {
      if (window.innerWidth >= 769 && !isLocked) {
        showTab(idx);
      }
    });

    btn.addEventListener("mouseleave", function() {
      if (window.innerWidth >= 769 && !isLocked) {
        showTab(activeIdx);
      }
    });

    btn.addEventListener("click", function() {
      isLocked = true;
      showTab(idx);
    });
  });

  window.addEventListener("resize", function() {
    if (window.innerWidth < 769) {
      isLocked = true;
    }
  });
};